import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService, OccConfig } from '@spartacus/core';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { Observable, take } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-returns-exit-popup',
  templateUrl: './returns-exit-popup.component.html',
  styleUrls: ['./returns-exit-popup.component.scss'],
  standalone: false
})
export class ReturnsExitPopupComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, protected config: OccConfig, private dialogRef: MatDialogRef<ReturnsExitPopupComponent>, private userInfoService: UserInfoService, private router: Router, private authService: AuthService, private cdr: ChangeDetectorRef) {

  }
  route: any;
  queryParams: any;
  isUserLoggedIn: Observable<boolean> = this.authService.isUserLoggedIn();

  goToreturn(): void {
    this.dialogRef.close();
    this.cdr.detectChanges();
    this.userInfoService.setPopUpValue(false);
    this.userInfoService.setInPlaceOrder(false);
    
  // 1) If popup was opened from Returns flow
    if (this.data?.fromReturns === true) {
      window.location.reload();
      return;
    }


    this.userInfoService.getRouteLink().subscribe(route => {
      this.route = route;
    });
    this.userInfoService.getQueryParams().subscribe(params => {
      this.queryParams = params;
    });

    let fromFooter: Boolean = false;
    this.userInfoService.getFromFooter().subscribe((data: Boolean) => {
      fromFooter = data;
    })
    if (fromFooter) {
      this.isUserLoggedIn.pipe(take(1)).subscribe((isLoggedIn: boolean) => {
        if (isLoggedIn) {
          this.handleLoggedInUser(this.route);
        } else {
          this.handleLoggedOutUser(this.route);
        }
      });
    }
    else if (this.route == "/my-profile" || this.route == "/my-account") {
      this.router.navigate([this.route]).then(() => {
        window.location.reload();
      });
    }
    else if (this.route == "switchAccount") {
      localStorage.removeItem('rbapermission');
      let selectedAccount: any;
      this.userInfoService.getSelectedAccount().subscribe(data => {
        selectedAccount = data;
      })
      this.userInfoService.changeB2BAccount(selectedAccount).subscribe((data) => {
        if (!this.router.url.includes('my-account')) {
          this.router.navigate(['/my-account']);
        }
        else {
          const url = (this.router.url).split('?')[0].split('#')[0];
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;

          //this.router.onSameUrlNavigation = 'reload';
          this.router.navigate([url.substring(url.lastIndexOf('/') + 1)], { onSameUrlNavigation: 'reload', queryParams: this.queryParams }).then(() => {
            this.cdr.detectChanges();
          });
        }
        this.userInfoService.updateUserdata();
      });
    }
    else {
      this.router.navigateByUrl('/', { onSameUrlNavigation: 'reload' }).then(() => {
        this.router.navigate([this.route], { queryParams: this.queryParams })
      });
      //this.router.navigate([this.route], { onSameUrlNavigation: 'reload' });
    }
  }
  closeDialog() {
    this.dialogRef.close();
  }
  // goToreturn(): void {
  //   window.location.reload();
  // }
  handleLoggedInUser(path: any) {
    if (path.includes('product') || path.includes('help-and-faq')) {
      this.handleLoggedOutUser(path);
    } else {
      localStorage.setItem('lastVisitedFooterUrl', path);
      localStorage.setItem('sessionTimedOut', 'true');
      this.authService.logout();
      this.router.navigate(['/logout']).then(() => {
      });
    }
  }

  handleLoggedOutUser(path: any) {
    this.router.navigate([path]);
  }
}
